import { getQuery, execQuery, luaScript } from '../../helpers/helper_store';
import cronstrue from 'cronstrue/i18n';
import { MessageBox } from 'element-ui';
import i18n from '@/locales';


const state = {
	selectedPacket: null,
	selectedJobId: null,
	cronPackets: null,
	sortType: 'name',
	packetInfo: null,
	templateTasks: null,
	scheduleFlag: {
		create: false,
		edit: false
	},
	jobsFlag: false
};

const mutations = {
	setPacket: (state, data) => (state.selectedPacket = data),
	setPacketName: (state, data) => (state.selectedPacket.name = data),
	setCronPackets: (state, { data, language }) => {
		let locale = language;
		if (language === "ua") locale = "uk";
		if (!!data) {
			let tmp = Array.isArray(data) ? data : [data];
			for (let packet of tmp) {
				for (let sch of packet.schedule) {
					if (sch.cronExp.split(" ").length !== 5) {
						sch.parseTime = sch.cronExp;
						MessageBox.alert(i18n.t("scheduleForm.incorrectFormat", {name: packet.name, schedule: sch.cronExp}));
					}
					else{
						sch.parseTime = cronstrue.toString(sch.cronExp, { use24HourTimeFormat: true, locale });
					}
				}
			}
			state.cronPackets = tmp;
		} else state.cronPackets = null;
	},
	setPacketInfo: (state, data) => (state.packetInfo = data),
	setJob: (state, data) => (state.selectedJobId = data),
	setScheduleFlag: (state, { action, value }) => (state.scheduleFlag[action] = value),
	setJobsFlag: (state, data) => (state.jobsFlag = data),
	sortPackets(state, sortType) {
		state.sortType = sortType;
		if (sortType === 'name') {
			state.cronPackets.sort((a, b) => {
				let nameA = a.name.toUpperCase();
				let nameB = b.name.toUpperCase();
				if (nameA < nameB) {
					return -1;
				}
				if (nameA > nameB) {
					return 1;
				}
				return 0;
			});
		} else if (sortType === 'hour') {
			state.cronPackets.sort((a, b) => {
				if (a.schedule.length === 0) return -1;
				if (b.schedule.length === 0) return 1;
				let cronTimeA = a.schedule[0].cronExp;
				let cronTimeB = b.schedule[0].cronExp;
				// console.log(cronTimeA);
				// console.log(cronTimeB);
				let hourA = cronTimeA.split(' ')[1];
				let hourB = cronTimeB.split(' ')[1];
				//может быть * -- редко, но нужно проверить
				if (hourA === '*') return 1;
				if (hourB === '*') return -1;
				if (hourA.includes(',')) hourA = hourA.split(',')[0];
				if (hourB.includes(',')) hourB = hourB.split(',')[0];
				if (hourA === hourB) {
					let minuteA = cronTimeA.split(' ')[0];
					let minuteB = cronTimeB.split(' ')[0];
					if (minuteA === '*') return 1;
					if (minuteB === '*') return -1;
					return parseInt(minuteA) - parseInt(minuteB);
				}
				return parseInt(hourA) - parseInt(hourB);
			});
		}
	}
};

const actions = {
	getPacketInfo({ rootState, commit, state }, idPacket = state.selectedPacket.id) {
		return new Promise((resolve, reject) => {
			luaScript('croneditor', 'readPacket', { idPacket }, rootState.login)
				.then((result) => {
					// console.log(result[0]);
					commit('setPacketInfo', result[0]);
					resolve();
				})
				.catch(() => reject());
		});
	},
	getCronPackets({ rootState, commit, state }, idCron = rootState.cron.cron.id) {
		return new Promise((resolve, reject) => {
			luaScript('croneditor', 'readPackets', { idCron }, rootState.login)
				.then((result) => {
					// console.log(rootState);
					commit('setCronPackets', { data: result, language: rootState.login.user.language });
					commit('sortPackets', state.sortType);
					resolve();
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	insCronPacket({ rootState, dispatch }, name) {
		return new Promise((resolve, reject) => {
			execQuery('insCronPacket', [rootState.cron.cron.id, name], rootState.login)
				.then(() => {
					return dispatch('getCronPackets');
				})
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	setJobsInPacket({ rootState, dispatch }, jobArray) {
		return new Promise((resolve, reject) => {
			luaScript('croneditor', 'savePacket', jobArray, rootState.login)
				.then(() => {
					return dispatch('getCronPackets');
				})
				.then(() => {
					return dispatch("getCron");
				})
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	updCronPacket({ rootState, dispatch, commit }, { name, id }) {
		return new Promise((resolve, reject) => {
			execQuery('updCronPacket', [id, name], rootState.login)
				.then(() => {
					return dispatch('getCronPackets');
				})
				.then(() => {
					commit("setPacketName", name);
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	delCronPacket({ rootState, dispatch }, idPacket) {
		return new Promise((resolve, reject) => {
			luaScript('croneditor', 'deletePacket', { idPacket }, rootState.login)
				.then(() => {
					return dispatch('getCronPackets');
				})
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	createMultiplePackets({ rootState, dispatch }, configObject) {
		return new Promise((resolve, reject) => {
			luaScript('cronmaker', 'swarm', configObject, rootState.login)
				.then(() => {
					return dispatch('getCronPackets');
				})
				.then(() => {
					resolve();
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	deleteMultiplePackets({ rootState, dispatch }, idArray) {
		return new Promise((resolve, reject) => {
			luaScript('cronmaker', 'crush', { packets: idArray }, rootState.login)
				.then(() => {
					return dispatch('getCronPackets');
				})
				.then(() => {
					resolve();
				})
				.catch((error) => {
					reject(error);
				});
		});
	},
	addCronSchedule({ rootState, dispatch }, { idPacket, cronExp, disabled }) {
		return new Promise((resolve, reject) => {
			execQuery('addCronSchedule', [idPacket, cronExp, disabled], rootState.login)
				.then((result) => {
					return dispatch('getCronPackets');
				})
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	editCronSchedule({ rootState, dispatch }, { id, cronExp, disabled }) {
		return new Promise((resolve, reject) => {
			execQuery('updCronSchedule', [id, cronExp, disabled], rootState.login)
				.then((result) => {
					return dispatch('getCronPackets');
				})
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	},
	delCronSchedule({ rootState, dispatch }, id) {
		return new Promise((resolve, reject) => {
			execQuery('delCronSchedule', [id], rootState.login)
				.then((result) => {
					return dispatch('getCronPackets');
				})
				.then(() => {
					resolve();
				})
				.catch(() => {
					reject();
				});
		});
	}
};

const getters = {
	packetInfo: (state) => state.packetInfo,
	selectedPacket: (state) => state.selectedPacket,
	cronPackets: (state) => state.cronPackets,
	createScheduleFlag: (state) => state.scheduleFlag.create,
	editScheduleFlag: (state) => state.scheduleFlag.edit,
	jobsFlag: (state) => state.jobsFlag
};

export default {
	state,
	mutations,
	actions,
	getters
};
